export const MULTI_CHAIN_ECDSA_VALIDATOR_ADDRESS = "0x5C97aA67Ba578E3c54ec5942A7563Ea9130E4f5F";
//# sourceMappingURL=constants.js.map